import { useCompany } from "#modules/company/view/useCompany";
import { getCompanyModelType } from "#modules/quoteRequestLines/helpers/getCompanyModelType";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { PredictionModelTypeSchema } from "shared";

export const useCouldCallPredict = ({
  quoteRequestLine,
}: {
  quoteRequestLine: QuoteRequestLineDto | null | undefined;
}) => {
  const { company } = useCompany();
  const modelType = getCompanyModelType(company);

  if (!quoteRequestLine) {
    return false;
  }

  const hasCluster = (quoteRequestLine.cluster?.targetQuoteRequestLines.length || 0) > 0;

  if (modelType === PredictionModelTypeSchema.enum.CLUSTERING) {
    return hasCluster;
  }

  return true;
};
